// /*
// * Palo Alto Theme
// *
// * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
// * Javascript in this fill will make it easier to update Palo Alto. In order
// * to use this file you will need to open layout/theme.liquid and uncomment
// * the custom.js script import line near the bottom of the file.
// */

// // (function() {
// //   // Add custom code below this line


// //   // ^^ Keep your scripts inside this IIFE function call to
// //   // avoid leaking your variables into the global scope.
// // })();


// This function allows to find elements in the sidebar to target headers to be automatically expanded e.g Store and About. For the elements, search for 'Sidebar Custom Code' in the assets/theme.css file
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Find all collapsible buttons
    const collapsibleButtons = document.querySelectorAll('[data-collapsible-trigger]');
    
    // Loop through each button
    collapsibleButtons.forEach(function(button) {
      // Get the associated text or attribute for each button
      const associatedLink = button.previousElementSibling;
      if (associatedLink) {
        const buttonText = associatedLink.textContent.trim().toLowerCase();

        // Automatically expand "Store" and "About" headers
        if (buttonText === 'store' || buttonText === 'about') {
          button.setAttribute('aria-expanded', 'true');

          // Hide the icons for Store and About
          const icons = button.querySelectorAll('svg.icon-toggle-plus, svg.icon-toggle-minus');
          icons.forEach(icon => {
            icon.style.display = 'none'; // Hide both plus and minus icons
          });

          // Find the corresponding dropdown content and show it
          const dropdown = button.nextElementSibling;
          if (dropdown && dropdown.getAttribute('data-collapsible-container') !== null) {
            dropdown.style.display = 'block'; // Show dropdown for Store and About
          }
        } 
        // For "Support", ensure it's closed by default (collapsible)
        else if (buttonText === 'support') {
          button.setAttribute('aria-expanded', 'false'); // Set to false to be collapsed by default

          // Hide the corresponding dropdown content
          const dropdown = button.nextElementSibling;
          if (dropdown && dropdown.getAttribute('data-collapsible-container') !== null) {
            dropdown.style.display = 'none'; // Keep hidden by default
          }

          // Add a click event to toggle the "Support" dropdown
          button.addEventListener('click', function() {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !expanded); // Toggle expanded state
            dropdown.style.display = expanded ? 'none' : 'block'; // Show/hide dropdown
          });
        }

        // For other buttons, ensure they are closed by default
        else {
          button.setAttribute('aria-expanded', 'false'); // Set to false to be collapsed by default
          const dropdown = button.nextElementSibling;
          if (dropdown && dropdown.getAttribute('data-collapsible-container') !== null) {
            dropdown.style.display = 'none'; // Ensure they are hidden
          }

          // Add click event to toggle any other sections
          button.addEventListener('click', function() {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !expanded); // Toggle expanded state
            dropdown.style.display = expanded ? 'none' : 'block'; // Show/hide dropdown
          });
        }
      }
    });
  });
})();
